import { getCurrencyDisplayLabel } from '../../utils/currencyDisplay';

const pad = (n) => String(n).padStart(2, '0');

export const toApiDateTime = (dateOnly) => {
  if (!dateOnly) return null;
  return `${dateOnly}T00:00:00.000Z`;
};

const addDaysToDateString = (dateStr, days) => {
  const d = new Date(`${dateStr}T12:00:00`);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** Politika önerisi — gönderimde form değerleri esastır. */
export const buildDuesFormDefaults = (policy) => {
  const year = new Date().getFullYear();
  const dueDay = Math.min(Math.max(Number(policy?.dueDay) || 30, 1), 28);
  const grace = Number(policy?.gracePeriodDays) || 15;
  const dueDate = `${year}-06-${pad(dueDay)}`;

  return {
    period: String(year),
    amount: policy?.amount ?? '',
    dueDate,
    finalDueDate: addDaysToDateString(dueDate, grace),
    description: policy?.description || '',
  };
};

export const formatDuesDate = (dateString) => {
  if (!dateString) return '-';
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' });
};

export const formatDuesMoney = (amount, currency = 'TRY') => {
  if (amount == null || Number.isNaN(Number(amount))) return '-';
  const formatted = Number(amount).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${getCurrencyDisplayLabel(currency)}`;
};
